// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"d5370986","674":"280de5b3","793":"ab9bccdf"}[chunkId] + ".chunk.css";
};